import { render } from "./YanJiuView.vue?vue&type=template&id=2eae2f78&scoped=true&ts=true"
import script from "./YanJiuView.vue?vue&type=script&lang=ts"
export * from "./YanJiuView.vue?vue&type=script&lang=ts"

import "./YanJiuView.vue?vue&type=style&index=0&id=2eae2f78&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\newbdb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eae2f78"]])

export default __exports__